import { Box } from '@mui/material';

import { useGetCurrentUserQuery } from '@/apis/extended/userApi';
import { shouldShowUserLoanStatusChips } from '@/components/Profile/userLoanStatus';
import { UserLoanStatusChips } from '@/components/Profile/UserLoanStatusChips';

/** Top-of-page row for loan tabs — mirrors the badge row on property detail cards. */
export function LoanFlowStatusBar() {
  const { data: user } = useGetCurrentUserQuery();
  if (!shouldShowUserLoanStatusChips(user)) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        minHeight: 28,
        mb: 2,
      }}
    >
      <UserLoanStatusChips />
    </Box>
  );
}

export function LoanFlowPageFrame({ children }: { children: React.ReactNode }) {
  return (
    <Box>
      <LoanFlowStatusBar />
      <Box>{children}</Box>
    </Box>
  );
}
